import { createFileRoute } from '@tanstack/react-router';
import {
  payrollAgreementDetailScreen,
  payrollAgreementDetailSearch,
  loadPayrollAgreementMessages,
  loadPayrollAgreementScreens,
} from '@/modules/payroll-agreement/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';
export const Route = createFileRoute('/_app/cadastro/convenios/$convenioId/')({
  validateSearch: payrollAgreementDetailSearch,
  staticData: { screen: payrollAgreementDetailScreen },
  loader: () => loadPayrollAgreementMessages(),
  component: lazyScreen(loadPayrollAgreementScreens, 'PayrollAgreementFormPage'),
});
